var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "61",
        height: "60",
        viewBox: "0 0 61 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M55.0195 22H5.01953V20H55.0195V22Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M55.0195 30H5.01953V28H55.0195V30Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M55.0195 38H5.01953V36H55.0195V38Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M37 55L37 5L39 5L39 55L37 55Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M29 55L29 5L31 5L31 55L29 55Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M21 55L21 5L23 5L23 55L21 55Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", { attrs: { d: "M13 12H47V46H13V12Z", fill: "#E1503C" } }),
      _vm._v(" "),
      _c("path", { attrs: { d: "M21 20H39V38H21V20Z", fill: "black" } }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M37 22H23V36H37V22ZM21 20V38H39V20H21Z",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }